<template>
    <custom-dialog width="485px" :showClose="true" title="快递信息" v-if="visibleObj.deliveryDialog"
        :visible="visibleObj.deliveryDialog" @close="dialogVisible('deliveryDialog')" @save="comfirm">
        <el-form slot="content" class="deliveryFrom" :rules="rules" ref="form" label-position="left"
            :model="deliveryFrom" label-width="80px">
            <el-form-item label="收货地址" prop="deliveryMemberId">
                <custom-input type="textarea" autosize v-if="disabled" disabled
                    v-model="deliveryFrom.addressDetail"></custom-input>
                <el-popover v-else ref="popover" placement="bottom" width="400" trigger="click">
                    <div class="address-list">
                        <div @click="selectAddress(item.deliveryMemberId)" class="address-item"
                            v-for="item in addressList" :key="item.deliveryMemberId">
                            <div>
                                <span class="color1F23">{{ item.consigneeName }}</span>
                                <span class="color6671 ml8"> {{ item.phone }}</span>
                                <custom-button v-if="!disabled" type="text"
                                    @click.stop="editAddress(item)">修改</custom-button>
                            </div>
                            <div class="color6671 mt6">{{ item.provinceName }}{{ item.cityName }}{{ item.regionName }}{{
        item.scopeName }}{{ item.detailedAddress }}</div>
                        </div>
                        <div class="add-warp" v-if="!disabled" @click="handleAdd">添加收货地址</div>
                    </div>
                    <div slot="reference" class="address-warp">
                        <!-- <div slot="reference" class="address-warp" @click="getAdrressList(patientInfo.patientId)"> -->
                        <div>{{ deliveryFrom.consigneeName }} {{ deliveryFrom.phone }}</div>
                        <div>{{ deliveryFrom.provinceName }}{{ deliveryFrom.cityName }}{{ deliveryFrom.regionName }}{{
        deliveryFrom.scopeName }}{{ deliveryFrom.detailedAddress }}</div>
                    </div>
                    <!-- <custom-input slot="reference" v-model="deliveryFrom.address"></custom-input> -->
                </el-popover>
            </el-form-item>
            <el-form-item label="配送公司" prop="companyName">
                <custom-select :disabled="disabled" v-model="deliveryFrom.companyName" placeholder="请选择配送公司"
                    :options="companyList" :configs="companyNameConfig" @change="companyChange"></custom-select>
            </el-form-item>
            <el-form-item label="付款方式" prop="chargeWay">
                <custom-select :disabled="disabled" @change="chargeWayChange" v-model="deliveryFrom.chargeWay"
                    placeholder="请选择付款方式" :options="payWayList"></custom-select>
            </el-form-item>
            <el-form-item label="费用预估" prop="price" v-if="showPrice">
                <div class="display-f">
                    <custom-input class="w120" :disabled="deliveryFrom.chargeWay == '0' || disabled"
                        v-model.trim="deliveryFrom.price"></custom-input>
                    <div v-if="showTips" class="ml8 colorFE8F">该区域未匹配快递自动算费规则</div>
                </div>
            </el-form-item>
            <el-form-item label="快递单号" prop="deliveryNumber">
                <custom-input :disabled="disabled" v-model.trim="deliveryFrom.deliveryNumber"></custom-input>
            </el-form-item>
        </el-form>
    </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import CustomSelect from '@/components/CustomSelect'
import { patientDTO } from '@/DTO/index'
import { isNull, isNullObj, checkReg, isEmptyArray } from '@/utils/validateBase'
import { deliveryDTO } from '@/DTO/index'
import { positiveInteger } from '@/utils/regexp'
export default {
    // 定义引入的组件
    components: { CustomDialog, CustomInput, CustomSelect },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        let checkPositiveInteger = (rule, value, callback) => {
            if (!checkReg(positiveInteger, value)) {
                return callback(new Error(`请输入正整数`));
            }
            return callback();
        }
        return {
            showTips: false,
            deliveryFrom: {
                companyName: '顺丰同城',//配送公司
                deliveryNumber: '',//运单号
                price: '',//快递费
                chargeWay: '1',//付款方式
            },//快递信息
            companyList: [],//配送公司列表
            rules: {
                deliveryMemberId: [
                    { required: true, message: '请选择收货地址', trigger: 'change' },
                ],
                companyName: [
                    { required: true, message: '请选择配送公司', trigger: 'change' },
                ],
                chargeWay: [
                    { required: true, message: '请选择付款方式', trigger: 'change' },
                ],
                price: [
                    { required: true, message: '请输入预估费用', trigger: 'blur' },
                    { validator: checkPositiveInteger, trigger: 'blur' }
                ],
            },
            addressList: [],//收货地址列表
            payWayList: [
                { label: '寄付', value: '1' },
                { label: '到付', value: '0' },
            ],//付款方式
            companyNameConfig: {
                value: 'name',
                label: 'name',
                text: 'name'
            },
            showPrice: true,//是否显示快递费
            disabled: false
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() {
        let { patientInfo, deliveryObj, showPrice, disabled } = this.dialogObj
        this.patientInfo = patientInfo
        this.disabled = disabled
        this.showPrice = isNull(showPrice) ? true : false
        if (isNull(deliveryObj) || isNullObj(deliveryObj)) {
            this.deliveryFrom = {
                deliveryMemberId: '',
                companyName: '顺丰同城',//配送公司
                deliveryNumber: '',//运单号
                price: '',//快递费
                chargeWay: '1',//付款方式
            }
        } else {
            this.deliveryFrom = deliveryObj
        }
        if (!isNull(this.patientInfo.patientId)) {
            this.getAdrressList(this.patientInfo.patientId).then(list => {
                if (!isEmptyArray(list)) {
                    if (isNull(deliveryObj) || isNullObj(deliveryObj)) {
                        let obj = list[0]
                        this.deliveryFrom = { ...this.deliveryFrom, ...obj, }
                        let { provinceId, regionId, scopeId, cityId, companyName } = this.deliveryFrom
                        let params = { provinceId, regionId, scopeId, cityId, companyName }
                        this.getDeliveryPrice(params)
                    }
                }
            })
        }
        this.getCompanyList(this.patientInfo.patientId)
    },
    // 页面DOM加载完成
    mounted() {
        // 组件传递
        this.$bus.$on('addressChange', (data) => {
            this.getAdrressList(this.patientInfo.patientId).then(list => {
                let item = list&&list.find(v=>{return data == v.deliveryMemberId})
                this.deliveryFrom = { ...this.deliveryFrom, ...item||{}, }
                let { provinceId, regionId, scopeId, cityId, companyName } = this.deliveryFrom
                if(!isNull(companyName)){
                    let params = { provinceId, regionId, scopeId, cityId, companyName }
                    this.getDeliveryPrice(params)
                }
                // this.$bus.$off('addressChange')
                // list.forEach(item => {
                //     if (data == item.deliveryMemberId) {
                        // this.deliveryFrom = { ...this.deliveryFrom, ...item, }
                        // let { provinceId, regionId, scopeId, cityId, companyName } = this.deliveryFrom
                        // if (!isNull(companyName)) {
                        //     let params = { provinceId, regionId, scopeId, cityId, companyName }
                        //     this.getDeliveryPrice(params)
                        // }
                    // }
                // })
            })
        })
        this.$bus.$on('addressDelete', () => {
            this.getAdrressList(this.patientInfo.patientId).then(list => {
                this.deliveryFrom = {
                    deliveryMemberId: '',
                    companyName: '顺丰同城',//配送公司
                    deliveryNumber: '',//运单号
                    price: '',//快递费
                    chargeWay: '1',//付款方式
                }
            })

        })

    },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 切换配送公司
         */
        companyChange(val) {
            let { provinceId, regionId, scopeId, cityId } = this.deliveryFrom
            let params = {
                provinceId, regionId, scopeId, cityId, companyName: val
            }
            this.getDeliveryPrice(params)
        },
        /**
         * 计算配送价格
         */
        async getDeliveryPrice(params) {
            if (isNull(this.dialogObj.recipesList)) return
            this.showTips = false
            if (this.deliveryFrom.chargeWay == '0') {
                this.deliveryFrom.price = isNull(this.deliveryFrom.price) ? 0 : this.deliveryFrom.price
                return
            }
            let doseNum = 0
            let weight = 0
            let drugPrice = 0
            this.dialogObj.recipesList.forEach(item => {
                drugPrice = this.$bigNumber(drugPrice, '+', isNull(item.totalPrice) ? 0 : item.totalPrice)
                doseNum = this.$bigNumber(doseNum, '+', isNull(item.doseNum) ? 0 : item.doseNum)
                weight = this.$bigNumber(weight, '+', this.$bigNumber(isNull(item.weight) ? 0 : item.weight, '*', item.doseNum))
            })
            params.doseNumber = doseNum
            params.weight = weight
            params.drugPrice = drugPrice
            let { code, data } = await deliveryDTO.getDeliveryPrice(params);
            if (code == 200) {
                this.deliveryFrom.price = isNull(data) ? 0 : data
            } else if (code == 204) {
                this.showTips = true
                this.deliveryFrom.price = 0
            } else {
                this.deliveryFrom.price = 0
            }
        },
        /**
         * 获取物流公司
         */
        async getCompanyList() {
            let { code, data } = await deliveryDTO.getCompanyList();
            if (code == 200) this.companyList = data
        },
        /**
         * 获取当前患者收货地址列表
         */
        async getAdrressList(patientId) {
            return new Promise(async (resolve, reject) => {
                let { code, rows } = await patientDTO.addressList(patientId)
                if (code == 200) {
                    resolve(rows)
                    this.addressList = rows
                } else {
                    resolve([])
                }
            })
        },
        /**
         * 选择地址
         */
        selectAddress(id) {
            let obj = this.addressList.find(item => { return item.deliveryMemberId == id })
            this.deliveryFrom = { ...this.deliveryFrom, ...obj, }
            let { provinceId, regionId, scopeId, cityId, companyName } = this.deliveryFrom
            if (!isNull(companyName)) {
                let params = { provinceId, regionId, scopeId, cityId, companyName }
                this.getDeliveryPrice(params)
            }
            this.$refs.popover.doClose()
        },
        /**
         * 确定
        */
        comfirm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('updateData', this.deliveryFrom)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        /**
        * 关闭
        */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 添加地址
         */
        handleAdd() {
            this.dialogObj.addressObj = {}
            this.dialogObj.addressType = 'add'
            this.$emit("close", 'addressDialog');
        },
        /**
         * 修改地址
         */
        editAddress(item) {
            this.dialogObj.addressObj = item
            this.dialogObj.addressType = 'edit'
            this.$emit("close", 'addressDialog');
        },
        /**
         * 付款方式改变
         */
        chargeWayChange() {
            this.deliveryFrom.price = this.deliveryFrom.chargeWay == '0' ? 0 : this.deliveryFrom.price
            let { provinceId, regionId, scopeId, cityId, companyName } = this.deliveryFrom
            if (!isNull(companyName)) {
                let params = { provinceId, regionId, scopeId, cityId, companyName }
                this.getDeliveryPrice(params)
            }
        },
    },
}
</script>

<style lang="less" scoped>
/deep/.el-form-item__error {
    padding-top: 0;
}

.el-form-item {
    margin-bottom: 14px;
}

.address-warp {
    width: 100%;
    min-height: 32px;
    border-radius: 4px;
    border: 1px solid #D3D3D5;
    padding: 6px 12px;
    box-sizing: border-box;
}

.address-list {
    max-height: 290px;
    overflow: auto;

    .address-item {
        cursor: pointer;
        border-bottom: 1px solid #EBEAEE;
        padding-bottom: 10px;
    }

    .add-warp {
        color: #1890FF;
        text-align: center;
        padding-top: 8px;
        cursor: pointer;
    }
}
</style>